import { useOutletContext } from "react-router-dom";

import type { AppShellOutletContext } from "../components/AppShell";

/** Typed accessor for the AppShell outlet context. Use from any
 *  routed page that needs to call back into the shell - today the
 *  only consumer is SalePage's "View transactions" link, which
 *  toggles the recent-transactions side panel in place instead of
 *  navigating away. (#162) */
export function useAppShell(): AppShellOutletContext {
  return useOutletContext<AppShellOutletContext>();
}
